<template>
  <div class="filters-country">
    <div class="filters-country__title">
      {{ $t('country.title') }}
    </div>
    <ui-checkbox
      class="filters-country__checkbox"
      :id="`country-${s.key}`"
      v-for="s in countryObj.subdivisions"
      :key="s.key"
      v-model="model"
      :value="s.key"
    >
      <span class="filters-country__checkbox__label">
        <span class="filters-country__checkbox__label__name">
          {{ s.name[$i18n.locale] || s.name.default }}
        </span>
      </span>
    </ui-checkbox>
  </div>
</template>

<script>
import UiCheckbox from '@/components/UI/Checkbox.vue'

export default {
  name: 'FilterCountry',
  components: {
    UiCheckbox,
  },
  props: {
    countryObj: {
      type: Object,
      required: true,
    },
    currentCountries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.currentCountries
      },
      set(array) {
        this.$emit('update', array)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-country {
  &__title {
    @include sub-title;
  }

  &__checkbox {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      display: flex;
      justify-content: space-between;

      &__name {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
